import { render, staticRenderFns } from "./Inspector.vue?vue&type=template&id=19e9e81e"
import script from "./Inspector.vue?vue&type=script&lang=js"
export * from "./Inspector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports